import createIcon from '../../createIcon';

/**
 * @component @name TableRows
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgOEgzVjRIMjFWOFpNMjEgMTBIM1YxNEgyMVYxMFpNMjEgMTZIM1YyMEgyMVYxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TableRows = createIcon('TableRows', [
  ['path', { d: 'M21 8H3V4H21V8ZM21 10H3V14H21V10ZM21 16H3V20H21V16Z', key: '1wo9n7' }],
]);

export default TableRows;
